import Image from 'next/image';
import Link from 'next/link';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { ellipsis } from '../../../../public/assets/images';
import { productMock } from '../../../../store/my-product-mock';
import Badge from '../../../elements/badge';
import Button from '../../../elements/button';
import Table from '../../../elements/table';
import PageLoader from '../../page-loader';
import { statsMock } from '../../../../store/my-product-mock';
import moment from 'moment';
import { getDateTime } from '../../../../utils/formatters';

const VendorListTable = ({ initialProductData, stats }) => {
  const dataTable = React.useMemo(() => {
    return stats;
  }, [stats]);

  const column = React.useMemo(() => {
    return [
      {
        Header: 'Customer Name',
        accessor: 'name',
        Cell: ({ row }) => {
          return row.original.firstName
            ? `${row.original.firstName} ${row.original.lastName}`
            : '-';
        },
      },
      {
        Header: 'Email',
        accessor: 'email',
        Cell: ({ row }) => {
          return row.original.email ? `${row.original.email}` : '-';
        },
      },
      {
        Header: 'Sales Count',
        accessor: 'count',
      },
    ];
  }, []);

  // Popper Menu
  const PopperMenu = ({ context }) => {
    const [isOpen, setIsOpen] = useState(false);

    const data = [
      {
        item: 'View Stats',
        url: `#`,
      },
      { item: 'Edit Product Details', url: `#` },
    ];

    return (
      <div className="" onMouseLeave={() => setIsOpen(false)}>
        {isOpen && (
          <div>
            <RenderPopUp data={data} />
          </div>
        )}
        <button onMouseOver={() => setIsOpen(true)}>
          <Image src={ellipsis} alt="ellipsis" />
        </button>
      </div>
    );
  };

  // Render Popup menu
  const RenderPopUp = ({ data }) => {
    return (
      <ul className="p-2 w-48 h-auto shadow top-0 absolute right-0 bg-white z-50">
        {data.length > 0 &&
          data.map((list, idx) => {
            return (
              <Link href={list.url || '#'} key={idx} passHref>
                <li
                  className={`text-xs py-3 border-b-[1px] border-gray-100 hover:bg-gray-100 px-2 ${
                    idx === 0 ? 'border-t-[1px]' : null
                  }`}
                >
                  {list.item}
                </li>
              </Link>
            );
          })}
      </ul>
    );
  };

  return (
    <>
      <Table columns={column} data={dataTable} />
    </>
  );
};

const CustomerListTable = ({ stats }) => {
  const dataTable = React.useMemo(() => {
    return stats;
  }, [stats]);
  const column = React.useMemo(() => {
    return [
      {
        Header: 'Customer Name',
        accessor: 'name',
      },
      {
        Header: 'Email Address',
        accessor: 'email',
      },
      {
        Header: 'Phone',
        accessor: 'phone',
      },
      {
        Header: 'Status',
        accessor: 'paymentStatus',
        Cell: ({ row }) => {
          const renderStatusBadge = data => {
            switch (data) {
              case 'pending':
                return 'danger';
              case 'success':
                return 'success';
              default:
                return 'default';
            }
          };

          return (
            <Badge
              text={row.values.paymentStatus}
              status={renderStatusBadge(row.values.paymentStatus)}
            />
          );
        },
      },
      {
        Header: 'Price',
        accessor: 'price',
        Cell: ({ row }) => `$${row.values.price}`,
      },
      {
        Header: 'Date',
        accessor: 'createdAt',
        Cell: ({ row }) => getDateTime(row.values.createdAt),
      },
    ];
  }, []);

  // Popper Menu
  const PopperMenu = ({ context }) => {
    const [isOpen, setIsOpen] = useState(false);

    const data = [
      {
        item: 'View Stats',
        url: `#`,
      },
      { item: 'Edit Product Details', url: `#` },
    ];

    return (
      <div className="" onMouseLeave={() => setIsOpen(false)}>
        {isOpen && (
          <div>
            <RenderPopUp data={data} />
          </div>
        )}
        <button onMouseOver={() => setIsOpen(true)}>
          <Image src={ellipsis} alt="ellipsis" />
        </button>
      </div>
    );
  };

  // Render Popup menu
  const RenderPopUp = ({ data }) => {
    return (
      <ul className="p-2 w-48 h-auto shadow top-0 absolute right-0 bg-white z-50">
        {data.length > 0 &&
          data.map((list, idx) => {
            return (
              <Link href={list.url || '#'} key={idx} passHref>
                <li
                  className={`text-xs py-3 border-b-[1px] border-gray-100 hover:bg-gray-100 px-2 ${
                    idx === 0 ? 'border-t-[1px]' : null
                  }`}
                >
                  {list.item}
                </li>
              </Link>
            );
          })}
      </ul>
    );
  };

  return (
    <>
      <Table columns={column} data={dataTable} />
    </>
  );
};

export { VendorListTable, CustomerListTable };
